import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostIssueVisibilityRequest = {
	archive?: boolean;
	snoozeUntil?: string;
	sonarObjectId: number;
};

export const postIssueVisibility = createPostEndpoint<PostIssueVisibilityRequest>(
	(request) => `/api/v3/core/sonar-objects/issues/${request.sonarObjectId}/visibility`,
	{
		requestTransform: ({ sonarObjectId, ...rest }) => ({ ...rest })
	}
);
